export default {
    createSessions: '/session/createSessions',
    getSessions :'/session/getSessions',
    // getExams: '/newExam/getExams',
    // getExam: '/newExam/getExam',
    // deleteExam: '/newExam/deleteExam'
}
